import React, { useEffect, useState } from 'react';
import './IncorrectChamp.css';

interface Champion {
  id: number;
  name: string;
  positions: string[];
  region: string[];
  releaseYear: string[];
  src: string;
}

export const IncorrectChamp = (props: { championDictionary: Record<string, Champion[]>, squareId: string }) => {
    return (
      <div className='containerIncorrectChamps'>
        {Object.entries(props.championDictionary).map(([square, champions]: [string, Champion[]]) => (
          square === props.squareId ? (
            champions.map((champ) => (
                <span key={champ.id} style={{ backgroundColor: "#c53737" }} className='spanIncorrect scale'>
                    <img className='inImage' src={champ.src} alt="Image champion LoL" />
                    {champ.name.charAt(0).toUpperCase() + champ.name.slice(1)}
                </span>
            ))
          ) : null
        ))}
      </div>
    );
  };
  
